import { SearchOutlined } from '@ant-design/icons';
import { Button, Checkbox, Col, Form, Input, Layout, Modal, Row, Space } from 'antd';
import React, { useEffect, useState } from 'react';
import Header from '../../common/compornents/layout/header/Header';
import HeaderRow5 from '../../common/compornents/layout/header/HeaderRow5';
import NonyusakiSearchTable from '../../common/compornents/layout/table/NonyusakiSearchTable';
import { notificationError, notificationInfo } from '../../common/compornents/notification';
import { Const } from '../../common/constants/Constants';
import { Message } from '../../common/constants/Message';
import { generateMessage } from '../../common/util/MessageUtil';
import NonyusakiSearchServ from '../../services/NonyusakiSearchServ';
import NonyusakiMaintenance from '../nonyusakiMaintenance/NonyusakiMaintenance';

const { Footer } = Layout;

// 引数
interface IProps {
  // Modal表示用state
  visibleState: boolean;
  nonyuSaki?: any;
  tokCd: string;
  tokCd2: string;

  // 関数
  closeNonyusakiSearch: () => void;
  updateNonyusaki: (data: any) => void;
}

const NonyusakiSearch: React.FC<IProps> = (props: IProps) => {
  // セッション情報
  const tokCd = props.tokCd;
  const tokCd2 = props.tokCd2;
  const companyCode = sessionStorage.getItem(Const.LOCAL_STORAGE_VALUE.COMPANY_CD) ?? '';
  const accountId = sessionStorage.getItem(Const.LOCAL_STORAGE_VALUE.ACCOUNT_ID) ?? '';
  const companyName = sessionStorage.getItem(Const.LOCAL_STORAGE_VALUE.COMPANY_NAME) ?? '';
  const manager = sessionStorage.getItem(Const.LOCAL_STORAGE_VALUE.TANTO_NAME) ?? '';

  const [form] = Form.useForm();
  const [fixFlag, updateFixFlag] = useState(false); //修正チェックボックスフラグ
  const [maintenancePop, updateMaintenancePop] = useState(false); //納入先保守画面
  const [hensyuMode, updateHensyuMode] = useState('');
  const [nouCd, updateNouCd] = useState<number>();
  const [nonyusakiList, updateNonyusakiList] = useState<any[]>([]);
  const [rIdx, changeRowIndex] = useState(-1);

  // 検索処理
  const dataSearch = () => {
    form.validateFields().then(async () => {
      let data = form.getFieldsValue();

      // 画面に入力された条件
      var nouNm1 = data.nouNm1 || '';
      var nouNm2 = data.nouNm2 || '';
      var nouNm3 = data.nouNm3 || '';
      var adr1 = data.adr1 || '';
      var adr2 = data.adr2 || '';
      var adr3 = data.adr3 || '';
      var nouMemo1 = data.nouMemo1 || '';
      var nouMemo2 = data.nouMemo2 || '';
      var nouMemo3 = data.nouMemo3 || '';

      // APIに渡すパラメーターを設定
      var params = {
        tokCd,
        tokCd2,
        nouNm1,
        nouNm2,
        nouNm3,
        adr1,
        adr2,
        adr3,
        nouMemo1,
        nouMemo2,
        nouMemo3,
      };

      // テーブル情報を検索するAPIを呼び出しDBから値を取得
      await NonyusakiSearchServ.getNonyusakiSearchData(params)
        .then((json) => {
          if (json.data.length >= 1000) {
            notificationInfo('納入先検索', generateMessage(Message.INFO_MASSAGE.INF010));
          }
          updateNonyusakiList(() => json.data);
        })
        .catch((error) => {
          notificationError(
            '納入先検索',
            generateMessage(Message.ERROR_MASSAGE.ERR999, '納入先検索')
          );
        });
    });
  };

  // クリア処理
  const dataClear = () => {
    form.resetFields();
    updateNonyusakiList([]);
  };

  // 行選択
  useEffect(() => {
    if (rIdx >= 0) {
      if (fixFlag) {
        // セッション情報に編集モード（修正）セット
        updateNouCd(nonyusakiList[rIdx].nouCd);
        updateHensyuMode('02');
        updateMaintenancePop(true);
      } else {
        // 親画面にSEQ（納入先コード）セット
        props.updateNonyusaki(nonyusakiList[rIdx].nouCd);
        dataClear();
        props.closeNonyusakiSearch();
      }
      changeRowIndex(-1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rIdx]);

  // 納入先保守ポップアップを開く
  const openMaintenancePop = () => {
    // セッション情報に編集モード（新規）セット
    updateHensyuMode('01');
    updateMaintenancePop(true);
  };

  // 納入先保守ポップアップを閉じる
  const closeMaintenancePop = () => {
    dataSearch();
    updateMaintenancePop(false);
  };

  //閉じるボタン押下
  function winClose() {
    dataClear();
    props.closeNonyusakiSearch();
  }

  return (
    <>
      <NonyusakiMaintenance
        visibleState={maintenancePop}
        closeNonyusakiMaintenance={closeMaintenancePop}
        hensyuMode={hensyuMode}
        nouCd={nouCd}
      />
      <Modal closable={false} width={1500} visible={props.visibleState} footer={null}>
        <Header screenName={'納入先検索'} />
        <Form
          form={form}
          layout="horizontal"
          autoComplete="off"
          style={{ backgroundColor: '#e6f7ff' }}
        >
          {/* ヘッダ情報（お客先様からログインIDまで */}
          <HeaderRow5
            tokCd={[tokCd, tokCd2]}
            compnyCd={companyCode}
            compnyNm={companyName}
            accId={accountId}
            accNm={manager}
          />

          {/* 納入先名検索文字 */}
          <Row style={{ paddingTop: '1vh' }}>
            <Col
              xl={{ span: 3, offset: 2 }}
              lg={{ span: 4, offset: 1 }}
              md={{ span: 5, offset: 1 }}
              sm={{ span: 6, offset: 1 }}
              xs={{ span: 8, offset: 1 }}
            >
              <Form.Item label="納入先名検索文字"></Form.Item>
            </Col>
            <Col md={3} sm={5} xs={4}>
              <Form.Item name={'nouNm1'}>
                <Input maxLength={8} />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item>&</Form.Item>
            </Col>
            <Col md={3} sm={5} xs={4}>
              <Form.Item name={'nouNm2'}>
                <Input maxLength={8} />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item>&</Form.Item>
            </Col>
            <Col md={3} sm={5} xs={4}>
              <Form.Item name={'nouNm3'}>
                <Input maxLength={8} />
              </Form.Item>
            </Col>

            {/* 修正チェックボックス */}
            <Col xl={{ offset: 2 }} md={{ offset: 1 }} xs={{ offset: 17 }}>
              <Form.Item label="修正">
                <Checkbox onChange={() => updateFixFlag((prevState) => !prevState)} />
              </Form.Item>
            </Col>

            {/* 新規ボタン */}
            <Col offset={1}>
              <Form.Item>
                <Button type="primary" onClick={openMaintenancePop}>
                  新規
                </Button>
              </Form.Item>
            </Col>
          </Row>

          {/* 住所検索文字 */}
          <Row>
            <Col
              xl={{ span: 3, offset: 2 }}
              lg={{ span: 4, offset: 1 }}
              md={{ span: 5, offset: 1 }}
              sm={{ span: 6, offset: 1 }}
              xs={{ span: 8, offset: 1 }}
            >
              <Form.Item label="住所検索文字"></Form.Item>
            </Col>
            <Col md={3} sm={5} xs={4}>
              <Form.Item name={'adr1'}>
                <Input maxLength={8} />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item>&</Form.Item>
            </Col>
            <Col md={3} sm={5} xs={4}>
              <Form.Item name={'adr2'}>
                <Input maxLength={8} />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item>&</Form.Item>
            </Col>
            <Col md={3} sm={5} xs={4}>
              <Form.Item name={'adr3'}>
                <Input maxLength={8} />
              </Form.Item>
            </Col>
          </Row>

          {/* 納入先メモ検索文字 */}
          <Row>
            <Col
              xl={{ span: 3, offset: 2 }}
              lg={{ span: 4, offset: 1 }}
              md={{ span: 5, offset: 1 }}
              sm={{ span: 6, offset: 1 }}
              xs={{ span: 8, offset: 1 }}
            >
              <Form.Item label="納入先メモ検索文字"></Form.Item>
            </Col>
            <Col md={3} sm={5} xs={4}>
              <Form.Item name={'nouMemo1'}>
                <Input maxLength={8} />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item>&</Form.Item>
            </Col>
            <Col md={3} sm={5} xs={4}>
              <Form.Item name={'nouMemo2'}>
                <Input maxLength={8} />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item>&</Form.Item>
            </Col>
            <Col md={3} sm={5} xs={4}>
              <Form.Item name={'nouMemo3'}>
                <Input maxLength={8} />
              </Form.Item>
            </Col>

            {/* 検索ボタンとクリアボタン */}
            <Col xl={{ offset: 2 }} md={{ offset: 1 }} sm={{ offset: 15 }} xs={{ offset: 14 }}>
              <Space size={'large'}>
                <Button type="primary" onClick={dataSearch}>
                  <SearchOutlined />
                  検索
                </Button>
                <Button type="primary" onClick={dataClear}>
                  クリア
                </Button>
              </Space>
            </Col>
          </Row>
        </Form>

        {/* テーブル */}
        <Row style={{ paddingTop: '2vh', backgroundColor: '#e6f7ff' }}>
          <Col offset={1} xs={22}>
            <NonyusakiSearchTable
              dataNonyusaki={nonyusakiList}
              rowIndex={rIdx}
              changeRowIndex={changeRowIndex}
            />
          </Col>
        </Row>

        {/* 閉じるボタン */}
        <Footer
          style={{
            backgroundColor: '#e6f7ff',
            height: '70px',
          }}
        >
          <Row justify="end">
            <Col>
              <Button type="primary" onClick={winClose}>
                閉じる
              </Button>
            </Col>
          </Row>
        </Footer>
      </Modal>
    </>
  );
};

export default NonyusakiSearch;
